var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "icon-group.6427cbc7.png","uri@2x": __webpack_public_path__ + "icon-group.3dbf952b.png","uri@3x": __webpack_public_path__ + "icon-group.62c6d81f.png",
    width: 38,
    height: 38
});